import { SectionTypes } from '@common/enums/section-type-enum';
import { Section } from '@common/models/section-model';

const emptyArray = [] satisfies Section[];

/**
 * This makes a bottom section list from all defined SectionTypes, one Section per SectionType value
 * This is a fallback in case the retailer-specific sections file doesn't come through or is invalid and ensures that the user experience continues
 */
export const makeDefaultBottomList = (): Section[] => {
    const subSections = Object.keys(SectionTypes);

    const capitalizeSection = (section: string) => section[0].toUpperCase() + section.slice(1);

    return subSections.map((subSection, index) => {
        const newSubSection: Section = {
            name: capitalizeSection(subSection.replaceAll(/[-_.]/g, ' ')),
            sectionKey: subSection,
            stepNumber: index + 1,
            subSections: [subSection as SectionTypes],
            hideIfNoZip: true, //safest option
        };

        return newSubSection;
    }, emptyArray);
};
